
/**
 * Utility functions for camera operations
 */

/**
 * Determines if a camera type uses film
 * @param cameraType The type of camera
 * @returns True if the camera uses film, false otherwise
 */
export const isFilmCamera = (cameraType: string): boolean => {
  // These camera types typically use film
  const filmCameraTypes = [
    'slr',
    'rangefinder', 
    'medium_format',
    'large_format',
    'point_and_shoot',
    'instant'
  ];
  
  return filmCameraTypes.includes(cameraType.toLowerCase());
};

/**
 * Get the compatible film type for a camera based on its format
 * @param cameraFormat The format of the camera (e.g., 35mm, medium_format)
 * @returns The corresponding film type
 */
export const getCompatibleFilmType = (cameraFormat: string | null): "35mm" | "120" | "220" | "large_format" | null => {
  if (!cameraFormat) return null;
  
  const format = cameraFormat.toLowerCase();
  
  // Map camera formats to film types
  if (format === '35mm') return "35mm";
  if (format === 'medium_format') return "120"; // Medium format can use both 120 and 220
  if (format === 'full_frame') return "120";
  if (format === 'large_format') return "large_format";
  
  // Default case
  return null;
};
